import { FullUser } from "authentication/domain/FullUser";
import Header from "Dashboard/components/Header";
import BottomSection from "./scenes/Main/components/BottomSection";
import Toolbox from "./scenes/Main/components/Toolbox";
import TopSection from "./scenes/Main/components/TopSection";
import "./styles/main.scss";
import { useForm } from "react-hook-form";
import { IGetResourcesListRequestParams } from "./domain/IGetResourcesListRequestParams";

interface IProps {
  user?: FullUser;
}

const Index = (props: IProps) => {

  const defaultValues: IGetResourcesListRequestParams = {
    searchTerm: undefined,
  };

  const {
    register: registerSearch,
    handleSubmit: handleSubmitSearch,
    reset: resetSearch,
    control: controlSearch,
    getValues: getValuesSearch,
    setFocus: setFocusSearch,
    setValue: setValueSearch
  } = useForm<IGetResourcesListRequestParams>({ defaultValues });

  return (
    <>
      <Header title="Resursi" />
      <Toolbox
        registerSearch={registerSearch}
        handleSubmitSearch={handleSubmitSearch}
        resetSearch={resetSearch}
        controlSearch={controlSearch}
        getValuesSearch={getValuesSearch}
        setFocusSearch={setFocusSearch}
        setValueSearch={setValueSearch}
      />
      <main id="resources">
        <TopSection
          getValuesSearch={getValuesSearch}
          setValueSearch={setValueSearch}
        />
        <BottomSection />
      </main>
    </>
  );
};

export default Index;
